<template>
  <VRow
    no-gutters
    class="tab-panel"
  >
    <VCol
      cols="12"
      class="font-weight-bold text-uppercase px-3"
    >
      <label
        class="pt-4 pb-2 tab-label"
        data-testid="label"
      >
        {{ header }}
      </label>
      <VRow
        no-gutters
        class="pt-2 tab-content"
        data-testid="content"
      >
        <VCol cols="12">
          <slot />
        </VCol>
      </VRow>
    </VCol>
  </VRow>
</template>

<script lang="ts" setup>

interface Props {
 header?: string
}

withDefaults(defineProps<Props>(), {
  header: undefined
})
</script>

<style lang="scss" scoped>
</style>
